/* ---------------------------------------------------------------------
   FS · Favoritos (corazón en las tarjetas de producto)

   Guarda los handles marcados en el navegador del visitante
   (localStorage). NO envía nada a Shopify: no toca cuentas de cliente,
   ni carrito, ni checkout, ni la base de datos de la tienda.

   El corazón se inyecta por JavaScript sobre las tarjetas que ya
   renderiza el theme, así no hay que modificar snippets/card-product.liquid
   y desactivar todo esto es tan simple como no cargar este archivo.

   Si localStorage está bloqueado (modo incógnito estricto), la lista
   funciona igual durante la visita y simplemente no se recuerda después.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'fs_favoritos';
  var HEART =
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 ' +
    '3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78' +
    '-3.4 6.86-8.55 11.54L12 21.35z';

  // Respaldo en memoria para cuando localStorage no está disponible.
  var memory = null;

  function read() {
    if (memory) return memory.slice();
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      });
    } catch (e) {
      if (!memory) memory = [];
      return memory.slice();
    }
  }

  function write(list) {
    memory = list.slice();
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      memory = null;
    } catch (e) {
      /* se queda solo en memoria durante esta visita */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.push(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    return i === -1;
  }

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }

  function buttonHtml(handle, title) {
    return (
      '<button type="button" class="fs-wish" data-fs-wish' +
      ' data-fs-wish-handle="' + esc(handle) + '"' +
      ' aria-pressed="false"' +
      ' aria-label="Guardar ' + esc(title || 'este producto') + ' en favoritos"' +
      ' title="Agregar a favoritos">' +
      '<svg class="fs-wish__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + HEART + '"></path></svg></button>'
    );
  }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  // Los dos tipos de tarjeta que existen en el sitio: la del theme base (Dawn)
  // y la de las secciones propias (portada, "completa tu equipo", etc.).
  var TARGETS = [
    { card: '.card-wrapper', anchor: '.card__inner', title: '.card__heading' },
    { card: '.fs-card', anchor: '.fs-card__media', title: '.fs-card__title' }
  ];

  // Agrega el corazón a las tarjetas que todavía no lo tienen.
  function decorate() {
    TARGETS.forEach(function (t) {
      var cards = document.querySelectorAll(t.card);
      Array.prototype.forEach.call(cards, function (card) {
        var anchor = card.querySelector(t.anchor);
        if (!anchor || anchor.querySelector('[data-fs-wish]')) return;
        var handle = handleFromCard(card);
        if (!handle) return;
        var heading = card.querySelector(t.title);
        var title = heading ? heading.textContent.trim() : '';
        anchor.classList.add('fs-has-wish');
        anchor.insertAdjacentHTML('beforeend', buttonHtml(handle, title));
      });
    });
  }

  function paintButton(btn) {
    var on = has(btn.getAttribute('data-fs-wish-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('title', on ? 'Quitar de favoritos' : 'Agregar a favoritos');
  }

  function paintCount() {
    var n = read().length;
    var nodes = document.querySelectorAll('[data-fs-wish-count]');
    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function paintAll() {
    decorate();
    var buttons = document.querySelectorAll('[data-fs-wish]');
    Array.prototype.forEach.call(buttons, paintButton);
    paintCount();
  }

  // Un solo listener en el documento: sirve también para las tarjetas que
  // el theme repinta después (filtros, paginación, búsqueda predictiva).
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-fs-wish]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.getAttribute('data-fs-wish-handle'));
    paintAll();
    document.dispatchEvent(new CustomEvent('fs:wishlist:change'));
  });

  // Cuando el theme reemplaza la grilla (filtros, orden, paginación) hay que
  // volver a poner los corazones. Observamos solo el contenedor de la grilla.
  function watchGrid() {
    if (!window.MutationObserver) return;
    var target =
      document.getElementById('ProductGridContainer') ||
      document.getElementById('product-grid');
    if (!target) return;
    var timer = null;
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(paintAll, 60);
    }).observe(target, { childList: true, subtree: true });
  }

  function start() {
    paintAll();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Volver con el botón "atrás" restaura la página desde caché: repintamos.
  window.addEventListener('pageshow', paintAll);

  window.FSWishlist = {
    list: read,
    has: has,
    repaint: paintAll,
    heartPath: HEART,
    escape: esc
  };
})();
